import { render, staticRenderFns } from "./userExercises.vue?vue&type=template&id=40d6db3e&scoped=true"
import script from "./userExercises.vue?vue&type=script&lang=js"
export * from "./userExercises.vue?vue&type=script&lang=js"
import style0 from "./userExercises.vue?vue&type=style&index=0&id=40d6db3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6db3e",
  null
  
)

export default component.exports